import { useState } from "react";

const ImagenConFallback = ({ src, alt, className }) => {
  const [imgSrc, setImgSrc] = useState(src);
  const imagenFallback = "/assets/images/default.jpg";

  return (
    <img
      src={imgSrc}
      loading="lazy"
      alt={alt}
      className={className}
      onError={() => setImgSrc(imagenFallback)}
    />
  );
};

export default ImagenConFallback;